import { Dispatch, GetState } from '../redux/redux.types';
import { RouterContext } from '../types/router';
import { BI_SCHEMA } from '../utils/bi-logger/bi-events';
import { biLoggerActionCreator } from '../utils/bi-logger/bi-logger';
import { getCurrentPageName, getPreviousPage } from './router.selectors';

export const ROUTER_ACTION_NAMES = {
  SHOW: 'ROUTER_ACTION_NAMES__SHOW',
};

export const show = (path: string, context: RouterContext, error) => {
  return {
    type: ROUTER_ACTION_NAMES.SHOW,
    payload: {
      path,
      context,
      error,
    },
  };
};

export const sendPageLoadBiEvent =
  () => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const params = {
      previousPage: getPreviousPage(state) || '',
      pageName: getCurrentPageName(state) || '',
      referralUrl: document.referrer || '',
    };

    dispatch(
      biLoggerActionCreator({
        event: BI_SCHEMA.page.load,
        params,
      }),
    );
  };
